import { PolicyValidator, Policy } from '../policy.interface';

const appPolicy: PolicyValidator = {
    validate: (policy: Policy) => {
        return policy?.isOwner;
    }
};

export default appPolicy;
